import type { ApiResponse } from "~/types/ApiResponse";
import {
    ApiBaseService,
    type PaginatedFetch,
    type PaginatedFetchOptions,
} from "./ApiBaseService";
import type { Language, Country, Locale } from "~/models/Localization";
import type { FetchOptions} from "ofetch"

export default class LocalizationService extends ApiBaseService {
    public languages(
        options?: Partial<PaginatedFetchOptions>,
    ): PaginatedFetch<Language[]> {
        return this.paginate<Language[]>(
            this.route("api.languages.index", "/languages"),
            options as PaginatedFetchOptions,
        );
    }

    public countries(
        options?: Partial<PaginatedFetchOptions>,
    ): PaginatedFetch<Country[]> {
        return this.paginate<Country[]>(
            this.route("api.countries.index", "/countries"),
            options as PaginatedFetchOptions,
        );
    }

    public locales(
        options?: Partial<FetchOptions>,
    ): Promise<ApiResponse<Locale[]>> {
        return this.request<ApiResponse<Locale[]>>(
            this.route("api.locales.index", "/locales"),
            options,
        );
    }
}
